<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            DORA MAYER<br>
            <span style="line-height: 100%;" class="fontMS300">
                EL SOL QUE DISIPA LAS NUBES
            </span>
            <span style="line-height: 100%;" class="fontMS300">
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio16/dora-mayer">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio16/dora-mayer">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio16/dora-mayer">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio16/DM_000.jpg">

</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-justify  font-24">
                    <br>
                    DORA MAYER (1868-1969), PERIODISTA, ENSAYISTA Y ACTIVISTA PERUANISTA, 
                    NACIÓ EN HAMBURGO, ALEMANIA Y VIVIÓ EN EL PERÚ HASTA SU MUERTE. 
                    FUNDÓ LA ASOCIACIÓN PRO-INDÍGENA EN EL AÑO 1909, JUNTO CON EL FILÓSOFO 
                    PEDRO ZULEN Y EL SENADOR JOAQUÍN CAPELO. LA ASOCIACIÓN ATENDÍA LAS DENUNCIAS 
                    DE LAS COMUNIDADES INDÍGENAS QUE, A INICIOS DEL SIGLO XX, SUFRÍAN LA EXPROPIACIÓN 
                    DE SUS TIERRAS Y UNA VIOLENTA EXPLOTACIÓN LABORAL A MANOS DE LOS HACENDADOS, 
                    LAS COMPAÑÍAS MINERAS Y LOS BARONES DEL CAUCHO. 
                    <br>
                </p>
                <p class="fontMS100 text-justify  font-24 text-gris">
                    <br>
                    CARTAS Y PUBLICACIONES DE LA ASOCIACIÓN PRO-INDÍGENA 
                    A partir de la Colección Pedro Zulen de la Biblioteca Nacional, realizamos un recorrido por la 
                    selección de cartas y publicaciones de la Asociación Pro-Indígena, cuyos documentos retratan la 
                    opresión sistemática de las comunidades indígenas en el Perú a inicios del siglo XX, y describen 
                    los mecanismos utilizados por la Asociación y por las mismas comunidades para buscar justicia. 
                    Al mismo tiempo, en los ensayos y artículos de Dora Mayer, se esboza su lucha incansable en 
                    pro de la paz, la tolerancia y la solidaridad. 
                    <br>
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris_PR">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%" 
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-6" style="padding:0%">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS300 text-center colorPrincipal font-40">
                            UNA SOCIÓLOGA <br>
                        </p>
                    </div>
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    AUTODIDACTA
                </p>
                <div class="c100">
                    <img class="lineCel mt-3" width="100%" 
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-6 p5">
                        <p class="fontMS500 font-24">
                            DORA MAYER TUVO UNA FORMACIÓN AUTODIDACTA. BAJO LA TUTELA SEVERA DE SU MADRE SE CONVIRTIÓ 
                            EN UNA LECTORA ASIDUA DE LA SOCIOLOGÍA Y LA FILOSOFÍA. APRENDIÓ INGLÉS Y ALEMÁN, Y ESTUDIÓ 
                            LITERATURA EUROPEA. DE SU PADRE, APRENDIÓ EL CASTELLANO Y ADQUIRIÓ UNA PASIÓN POR LA JUSTICIA, 
                            EL COMPROMISO SOCIAL Y LA IGUALDAD.  
                            <br><br>
                        </p>
                        <img width="100%" src="/assets/images/micrositio/micrositio16/DM_030.jpg">
                        <!--<div class="row">
                            <div class="col-sm-12">
                                <img width="100%" src="/assets/images/micrositio/micrositio16/DM_030.jpg">
                            </div>
                        </div>-->
                    </div>
                    <div class="col-sm-6">
                        <div class="bottom_cel">
                            <br><br><br><br>
                        </div>
                        <p class="fontMS100 font-24">
                            <br>
                            Su amplia formación es notable desde sus 
                            primeras intervenciones periodísticas, 
                            recopiladas bajo el título Estudios sociológicos, 
                            en 1907. En este libro, Mayer comenta las teorías 
                            de Darwin y la sociología positivista de Herbert Spencer. 
                            Examina la situación de la mujer y de los indígenas 
                            en el Perú y, desde la filosofía, considera 
                            temas como la razón, el afecto y la ética. 
                        </p>
                        <div class="row mt5">
                            <div class="col-sm-10">
                                <p class="fontMS700 font-24">
                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                                    <a href="http://hdl.handle.net/20.500.14428/79315 " target="_blank" 
                                        style="color: black; text-decoration: none;">
                                        EL GÉNESIS CIENTÍFICO <br>
                                    </a>
                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                                    <a href="http://hdl.handle.net/20.500.14428/79314 " target="_blank"
                                        style="color: black; text-decoration: none;">
                                        LA MUJER Y EL MATRIMONIO <br>
                                    </a>
                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                                    <a href="http://hdl.handle.net/20.500.14428/79313 " target="_blank" 
                                        style="color: black; text-decoration: none;">
                                        EL PROBLEMA DE LA CARIDAD <br>
                                    </a>
                                    <img width="100%"
                                        src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-12">
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;" class="fontMS700 colorPrincipal2 font-40">
                    LA ASOCIACIÓN PRO-INDÍGENA
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 150%;margin-bottom: 0%;" class="fontMS700 colorPrincipal2 font-40">
                            (1906-1916)
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada_a.png">
                    </div>
                </div>
                <p class="fontMS500 font-24 text-white mt-5">
                    EN 1909, DORA MAYER PARTICIPÓ EN UNA SERIE DE CHARLAS SOBRE LA 
                    EDUCACIÓN DEL INDÍGENA EN EL CENTRO UNIVERSITARIO DE LA UNIVERSIDAD 
                    DE SAN MARCOS. A PARTIR DE ESTA EXPERIENCIA, ELLA FUNDA LA ASOCIACIÓN 
                    PRO-INDÍGENA, JUNTO CON EL FILÓSOFO PEDRO ZULEN Y EL SENADOR 
                    JOAQUÍN CAPELO. 
                    <br>
                </p>
                <p class="fontMS100 font-22 text-white">
                    <br>
                    La Asociación Pro-Indígena buscó poner fin a la explotación laboral y los atropellos legales que 
                    sufría la población indígena. Los fundadores desarrollaron tres líneas de acción: Fortalecieron 
                    las protecciones laborales a nivel nacional; ofrecieron asesoría legal a nivel local; y, al estilo de 
                    las ligas anti-esclavistas en Inglaterra, buscaron movilizar la opinión pública ante la situación 
                    del ciudadano indígena. Finalmente, la Asociación contó con una red de delegados en casi 
                    todas las regiones del país que comunicaban su situación laboral a través del envío de cartas. 
                    La correspondencia de estos asociados deja constancia de la magnitud del problema. Sus cartas 
                    retratan un contexto social dominado por el engaño, la explotación, la corrupción, la injusticia y la violencia. 
                    <br>
                </p>
                <br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br>
                <p class="fontMS500 font-45 text-white mt-3 mb-5">
                    EL ROL DE DORA MAYER
                </p>
                <div class="row">
                Some language features are not available. To access all features, enabl
                    <div class="col-sm-6">
                        <img width="100%" src="/assets/images/micrositio/micrositio16/DM_001.jpg">
                        <p class="fontMS100 font-22 text-white font-italic mt-2">
                            Dora Mayer en un viaje a Junín. Publicó relatos
                            sobre este viaje en una serie de artículos
                            titulada “Cartas del Perené”, 1903-1904.
                            Archivo familiar de José Respaldiza.
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 font-22 text-white ml-2">
                            Dora Mayer se dedicó a movilizar la opinión 
                            pública a través de sus escritos. 
                            Contribuyó con los medios más importantes de la época. 
                            También fundó la revista El Deber Pro-Indígena para 
                            difundir el trabajo de la Asociación. Desde 1914 asumió 
                            responsabilidades adicionales dentro de la organización. 
                            Ejerció la Presidencia cuando Joaquín Capelo tuvo un 
                            encargo ministerial y la Secretaría cuando Pedro Zulen 
                            viajó por motivos de salud. 
                            <br>
                        </p>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/74797" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio16/DM_002.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Pedro F. Mostajo. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Dora Mayer. 
                                        <br>
                                    </span>
                                    Lima, 18 de febrero de 1914.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/78536" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio16/DM_003.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Los reos de la cárcel de Cañete. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Dora Mayer.
                                        <br>
                                    </span>
                                    Cañete, 9 de marzo de 1915.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/73207" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio16/DM_004.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Dora Mayer.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a un colaborador de “El Deber Pro-Indígena”. 
                                        <br>
                                    </span>
                                    Callao, [s.f].
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br>
                <p class="fontMS500 font-45 text-white mt-3 mb-5">
                    ESCLAVITUD EN LA AMAZONÍA
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100 font-22 text-white">
                            Durante la fiebre del caucho, la goma de la 
                            Amazonía se convirtió en un codiciado producto de exportación para la producción 
                            industrial en el norte global. La explotación se extendió por Brasil, Perú, Colombia y 
                            Ecuador, afectando a las comunidades Bora, Huitota, Andoque, Ocaina, Nonuya, Muinane, 
                            Miraña, Yukuna, Matapí y Resígaro, entre otras. Un caso en particular que llegó a 
                            crear un verdadero escándalo internacional fue el del cauchero Julio C. Arana. 
                            El gobierno británico publicó una serie de informes sobre los abusos cometidos por 
                            su empresa. La Asociación Pro-Indígena sirvió de corresponsal para estas investigaciones 
                            y difundió el caso en El Deber Pro-Indígena. 
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img width="100%" src="/assets/images/micrositio/micrositio16/DM_005.jpg">
                        <p class="fontMS100 font-22 text-white font-italic mt-2">
                            Capataces de Barbados e indígenas Huitotos.
                            Fuente: Libro azul británico. IWGIA-CAAAP, 2011.
                        </p>
                    </div>
                </div>
                <div class="row" style="margin-top:10%">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/64315" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio16/DM_006.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Dora Mayer.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a J.C. Van Notten.  
                                        <br>
                                    </span>
                                    Ginebra, 9 de febrero de 1914.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/78511" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio16/DM_007.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Wenceslao Enit G. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Dora Mayer.  
                                        <br>
                                    </span>
                                    Río Huallaga, 1 de febrero de 1915.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-2"></div>
                </div>
                <br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br>
                <p class="fontMS500 font-45 text-white mt-3 mb-5">
                    ABUSOS LABORALES EN LA SIERRA CENTRAL
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <img width="100%" src="/assets/images/micrositio/micrositio16/DM_008.jpg">
                        <p class="fontMS100 font-22 text-white font-italic mt-2">
                            Cerro de Pasco Corporation: mineros de la
                            Compañía Puquiococha cerca de la mina
                            Alejandro, Morococha. Foto: Sebastián
                            Rodríguez. Fuente: Repositorio PUCP.
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 font-22 text-white ml-2">
                            En Lima, Áncash y Junín, la Asociación 
                            denunció las tácticas de engaño y coerción 
                            empleadas por las haciendas y las compañías 
                            mineras para conseguir mano de obra. 
                            El “enganche” era una de estas tácticas. 
                            Las compañías mineras ofrecían un adelanto 
                            significativo a los trabajadores y les quitaban 
                            la libertad hasta que cancelaban su deuda con el patrón. 
                            Ante cualquier queja eran amenazados con encarcelamiento 
                            o conscripción militar.
                            <br>
                        </p>
                    </div>
                </div>
                <div class="row" style="margin-top:10%">
                    <div class="col-sm-4 libro mt-3">
                        <a href="http://hdl.handle.net/20.500.14428/79276" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio16/DM_009.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Arturo E. Delgado. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Dora Mayer, Secretaria de la Asociación Pro-Indígena.   
                                        <br>
                                    </span>
                                    Oyón, 1 de marzo de 1914.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/63469" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio16/DM_010.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Dora Mayer. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Germán Carranza.  
                                        <br>
                                    </span>
                                    Callao, 11 de marzo de 1914.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/78519" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio16/DM_011.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Pío Quinto Chugo. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Dora Mayer.  
                                        <br>
                                    </span>
                                    Junín, 10 de febrero de 1915. 
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br>
                <p class="fontMS500 font-45 text-white mt-3 mb-5">
                    RESISTENCIA AL GAMONALISMO EN PUNO
                </p>
                <div class="row">
                    
                    <div class="col-sm-5">
                        <img width="100%" src="/assets/images/micrositio/micrositio16/DM_012.jpg">
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-6">
                        <p class="fontMS100 font-22 text-white ml-2">
                            Tras el alza del precio de la lana en el mercado internacional, 
                            los terratenientes intensificaron la explotación de las comunidades 
                            indígenas de Puno. Ante tales hechos, desde 1909, la Asociación 
                            Pro-Indígena atendió innumerables denuncias sobre el despojo de tierras, 
                            la imposición de servicio gratuito, intimidación y asesinatos en la región. 
                            Las cartas de los corresponsales dan cuenta de la persistencia de la organización 
                            comunal en la región y su importancia para la resistencia indígena. 
                            <br>
                        </p>
                    </div>
                </div>
                <div class="row" style="margin-top:10%">
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/76299" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio16/DM_026.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Rosa Carmen Quispe Coa 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Dora Mayer. 
                                        <br>
                                    </span>
                                    Puno, 28 de agosto de 1915. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/76046" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio16/DM_027.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Roberto Adriazola.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta dirigida al Sr. Joaquín Capelo o a la Srta. Dora Mayer.
                                        <br>
                                    </span>
                                    Puno, 19 de agosto de 1915. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/77487" target="_blank" style="color: black;">
                            <img class="p2" width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio16/DM_028.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Pablo Trujillano. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Carta a Dora Mayer.  
                                        <br>
                                    </span>
                                    Puno, 9 de febrero de 1914. 
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br>
                <p class="fontMS500 font-45 text-white mt-3 mb-5">
                    EL DEBER PRO-INDÍGENA
                </p>
                <div class="row bottom_cel">
                    <div class="col-sm-3">
                        <img width="100%" height="90%" src="/assets/images/micrositio/micrositio16/DM_016.jpg">
                    </div>
                    <div class="col-sm-9">
                        <p class="fontMS100 font-22 text-white">
                            En 1912 Dora Mayer funda El Deber Pro-Indígena con el fin de crear 
                            «una cátedra de moralidad y conciencia pública». En esta revista mensual, 
                            difunde las denuncias recibidas por la Asociación y noticias sobre la causa indígena. 
                            En el primer número aborda el caso del Putumayo, las matanzas durante la huelga de Chicama, 
                            los abusos cometidos por la Cerro de Pasco Mining Co., 
                            y la expropiación de tierras en la comunidad de Vicos. 
                            En los números posteriores, Dora Mayer, además, incorpora su propia creación literaria. 
                            El drama de la selva, publicado por entregas entre 1916 y 1917, 
                            explora la tensa convivencia entre personajes extranjeros, 
                            andinos y amazónicos en una hacienda cauchera. 
                            <br>
                        </p>
                    </div>
                </div>
                <div class="row c100">
                    <div class="col-sm-3">
                        <img width="100%" height="90%" src="/assets/images/micrositio/micrositio16/DM_016.jpg">
                    </div>
                    <div class="col-sm-12">
                        <p class="fontMS100 font-22 text-white">
                            <br>
                            En 1912 Dora Mayer funda El Deber Pro-Indígena con el fin de crear 
                            «una cátedra de moralidad y conciencia pública». En esta revista mensual, 
                            difunde las denuncias recibidas por la Asociación y noticias sobre la causa indígena. 
                            En el primer número aborda el caso del Putumayo, las matanzas durante la huelga de Chicama, 
                            los abusos cometidos por la Cerro de Pasco Mining Co., 
                            y la expropiación de tierras en la comunidad de Vicos. 
                            En los números posteriores, Dora Mayer, además, incorpora su propia creación literaria. 
                            El drama de la selva, publicado por entregas entre 1916 y 1917, 
                            explora la tensa convivencia entre personajes extranjeros, 
                            andinos y amazónicos en una hacienda cauchera. 
                            <br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-8">
                        <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <a href="http://hdl.handle.net/20.500.14428/79608" target="_blank" style="text-decoration:none;">
                        <p class="fontMS100 font-22 text-white font-weight-bold" style="margin:0%;">
                            <span class="fontMS100Italic">EL DEBER PRO-INDÍGENA</span>, N° 1, OCTUBRE DE 1912 
                        </p>
                    </a>
                    <div class="col-sm-8">
                        <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <a href="http://hdl.handle.net/20.500.14428/79607" target="_blank" style="text-decoration:none;">
                        <p class="fontMS100 font-22 text-white font-weight-bold" style="margin:0%;">
                            <span class="fontMS100Italic">EL DEBER PRO-INDÍGENA, BOLETÍN EXTRAORDINARIO</span>, ENERO DE 1916 
                        </p>
                    </a>
                    <div class="col-sm-8">
                        <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                    <a href="http://hdl.handle.net/20.500.14428/79641" target="_blank" style="text-decoration:none;">
                        <p class="fontMS100 font-22 text-white font-weight-bold" style="margin:0%;">
                            <span class="fontMS100Italic">EL DEBER PRO-INDÍGENA, N° 51, 1917.<br>
                            EL DEBER PRO-INDÍGENA:<br>
                            ÓRGANO DE LA ASOCIACIÓN PRO-INDÍGENA</span>, BOLETÍN N° 51, 1917. <br>
                        </p>
                    </a>
                    <div class="col-sm-8">
                        <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco_PR">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%" 
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%" 
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-6" style="padding:0%">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EL FORMIDABLE JUEZ <br>
                        </p>
                    </div>
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%" 
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    DE LA OPINIÓN PÚBLICA
                </p>
                <div class="c100">
                    <img class="lineCel mt-3" width="100%" 
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-center font-24 p2">
                            COLABORADORA ASIDUA DE LOS MEDIOS MÁS IMPORTANTES DE SU ÉPOCA, 
                            SUS ARTÍCULOS APARECIERON EN <span class="fontMS500Italic">EL COMERCIO, LA PRENSA, LA CRÓNICA, 
                            AMAUTA, EL CALLAO Y ORIENTAL: REVISTA DE LA COLONIA CHINA</span>. EN 1917, 
                            FUNDÓ <span class="fontMS500Italic">LA CRÍTICA</span> CON LA ABOGADA MIGUELINA ACOSTA, Y LA REVISTA FUE 
                            PROHIBIDA POR EL RÉGIMEN DE AUGUSTO B. LEGUÍA EN 1920. TAMBIÉN, 
                            DIRIGIÓ <span class="fontMS500Italic">CONCORDIA</span> (1928-1929) Y <span class="fontMS500Italic">EL TRABAJO</span> (1931-1934). 
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24">
                            A través del periodismo, Dora Mayer buscó influir en la opinión pública para encaminar las 
                            acciones de las autoridades e inculcar un sentido de responsabilidad, tolerancia y solidaridad 
                            en la sociedad en general. En sus artículos, entre otros temas, critica los prejuicios contra 
                            la colonia china, se alinea con las organizaciones femeninas internacionales por la paz, condena 
                            la militarización europea, denuncia la intervención de Estados Unidos en las negociaciones sobre 
                            Tacna y Arica, y aboga por el sufragio femenino y de la población analfabeta.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-bottom:5%;">
            <div class="col-sm-1"></div>
            <div class="col-sm-2 libro-small mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79636" target="_blank" style="color: black;">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio16/DM_017.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Dora Mayer. 
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                El peligro amarillo.  
                                <br>
                            </span>
                            La Crítica: semanario independiente, 31 de marzo de 1918.   
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro-small mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79628" target="_blank" style="color: black;">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio16/DM_031.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Dora Mayer. 
                                <br>
                            </span>
                            <span class="fontMS100Italic">
                                La mujer y el pacifismo.  
                                <br>
                            </span>
                            El Comercio, 1 de enero de 1921.    
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 mt-3">
                <a href="http://hemeroteca.mariategui.org/index.php/Detail/objects/7" target="_blank">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio16/DM_018.jpg">
                </a>
            </div>
            <div class="col-sm-2 mt-3">
                <a href="http://hemeroteca.mariategui.org/index.php/Detail/objects/2" target="_blank">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio16/DM_019.jpg">
                </a>
            </div>
            <div class="col-sm-2 libro-small mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79630" target="_blank" style="color: black;">
                    <img class="p2" width="100%" height="100%"
                        src="/assets/images/micrositio/micrositio16/DM_020.jpg">
                    <div class="overlay">
                        <p class="fontMS100 text-center">
                            <span class="fontMS100Italic">
                                Un estudio sobre el latifundismo.  
                                <br>
                            </span>
                            Concordia, no. 7, 10 de enero de 1929. 
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-1"></div>
        </div>
    </div>
</div>

<div class="fondoGris_PR1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png">
                <br><br>
                <p class="fontMS500 text-justify  font-24">
                    DORMIDA ESTABA, A LOS CIEN AÑOS DE EMANCIPACIÓN REPUBLICANA 
                    DEL PERÚ, LA CONCIENCIA DE LOS GOBERNANTES, LA CONCIENCIA DE 
                    LOS GAMONALES, LA CONCIENCIA DEL CLERO, LA CONCIENCIA DEL 
                    PÚBLICO ILUSTRADO Y SEMI-ILUSTRADO. <br>
                </p>
                <div class="col-sm-12 text-right mt-3 mb-3">
                    <span class="fontMS300Italic font-24">DORA MAYER, 1926.</span>
                </div>
                <img class="reflejo" width="100%" 
                src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco_PR">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%" 
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-6" style="padding:0%">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EL SOL QUE DISIPA <br>
                        </p>
                    </div>
                    <div class="col-sm-3" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    LAS NUBES
                </p>
                <div class="c100">
                    <img class="lineCel mt-3" width="100%" 
                        src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                </div>
                <div class="row mt-5 bottom_cel">
                    <div class="col-sm-6">
                        <p class="fontMS500 font-24 mr-2">
                            DORA MAYER TRABAJÓ TODA SU VIDA A FAVOR DE LA CAUSA INDÍGENA. 
                            CON MOTIVO DEL CENTENARIO DE LA INDEPENDENCIA DEL PERÚ, 
                            PUBLICÓ EL INDÍGENA PERUANO A LOS CIEN AÑOS DE REPÚBLICA LIBRE 
                            E INDEPENDIENTE. EN ESTE LIBRO SOSTIENE QUE LA EMANCIPACIÓN SOLO
                            FUE PARA LOS MESTIZOS, PORQUE LA SITUACIÓN DE LOS PERUANOS 
                            NEGROS E INDÍGENAS NO HABÍA MEJORADO DURANTE LA ERA REPUBLICANA. 
                            DESCRIBE EL PERÚ DEL CENTENARIO COMO UN PAÍS DE AMOS Y ESCLAVOS, 
                            UN PAÍS DONDE LOS VERDADEROS DUEÑOS DEL PAÍS, LOS INDÍGENAS, 
                            SUFREN PERJUICIOS, MALTRATO Y EXPLOTACIÓN. 
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <div class="row mb-5">
                            <div class="col-sm-7 libro">
                                <a href="http://hdl.handle.net/20.500.14428/79177 " target="_blank" style="color: black;">
                                    <img class="p2" width="100%" height="100%"
                                        src="/assets/images/micrositio/micrositio16/DM_021.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS500">
                                                Dora Mayer. 
                                                <br>
                                            </span>
                                            <span class="fontMS100Italic">
                                                El indígena y su derecho.  
                                                <br>
                                            </span>
                                            [Imprenta J.E. Chenyek], 1929.     
                                        </p>
                                    </div>
                                </a>
                            </div>
                            <div class="col-sm-5"></div>
                        </div>
                        <p class="fontMS100 font-24">
                            Del mismo modo, en el año 1929, publicó una defensa apasionada del sistema colectivista de 
                            las comunidades indígenas. El motivo de este ensayo fue un proyecto de ley que buscaba 
                            convertir al indígena comunero en propietario individual para incorporarlo al proyecto 
                            modernizador de la nación. Dora Mayer sostiene que es una propuesta paternalista. 
                            Critica la supuesta «verdad universal» del Derecho Romano que sirve de sustento a dicha ley. 
                            Expone los intereses imperialistas de Estados Unidos y asevera que la reforma tendrá un 
                            efecto desmoralizador y aniquilador para la población indígena. 
                            <br>
                        </p>
                    </div>
                </div>
                <div class="row mt-5 c100">
                    <div class="col-sm-6">
                        <p class="fontMS500 font-24 mr-2">
                            DORA MAYER TRABAJÓ A FAVOR DE LA CAUSA INDÍGENA A LO LARGO DE
                            SU VIDA. CON MOTIVO DEL CENTENARIO DE LA INDEPENDENCIA
                            DEL PERÚ, PUBLICÓ EL INDÍGENA PERUANO A LOS CIEN AÑOS DE
                            REPÚBLICA LIBRE E INDEPENDIENTE. EN ESTE LIBRO SOSTIENE QUE LA
                            EMANCIPACIÓN SOLO FUE PARA LOS MESTIZOS, PORQUE LA SITUACIÓN
                            DE LOS PERUANOS NEGROS E INDÍGENAS NO HABÍA MEJORADO
                            DURANTE LA ERA REPUBLICANA. DESCRIBE EL PERÚ DEL CENTENARIO
                            COMO UN PAÍS DE AMOS Y ESCLAVOS, UN PAÍS DONDE LOS
                            VERDADEROS DUEÑOS DEL PAÍS, LOS INDÍGENAS, SUFREN PREJUICIOS,
                            MALTRATO Y EXPLOTACIÓN. <br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <div class="row mb-5">
                            <div class="col-sm-12 libro">
                                <a href="http://hdl.handle.net/20.500.14428/79177 " target="_blank" style="color: black;">
                                    <img class="p2" width="100%" height="100%"
                                        src="/assets/images/micrositio/micrositio16/DM_021.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS500">
                                                Dora Mayer. 
                                                <br>
                                            </span>
                                            <span class="fontMS100Italic">
                                                El indígena y su derecho.  
                                                <br>
                                            </span>
                                            [Imprenta J.E. Chenyek], 1929.     
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <p class="fontMS100 font-24">
                            Del mismo modo, en el año 1929 publicó una defensa apasionada del sistema colectivista de
                            las comunidades indígenas. El motivo de este ensayo fue un proyecto de ley que buscaba
                            convertir al indígena comunero en propietario individual para incorporarlo al proyecto
                            modernizador de la nación. Dora Mayer sostiene que es una propuesta paternalista.
                            Critica la supuesta verdad universal del Derecho Romano que sirve de sustento,
                            expone los intereses imperialistas de Estados Unidos y asevera que la reforma tendrá un
                            efecto desmoralizador y aniquilador para la población indígena. <br>
                        </p>
                    </div>
                </div>
                <br><br><br>
                <img width="100%" src="/assets/images/micrositio/micrositio10/ET04_MS15_PENSA__LINEA2.jpg">
                <br><br><br><br>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-2" style="padding:0%">
                                <img class="LineSubsec bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                            </div>
                            <div class="c100">
                                <img class="lineCel mb-3" width="100%" 
                                    src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                            </div>
                            <div class="col-sm-8" style="padding:0%">
                                <p style="line-height: 160%;margin-bottom: 0%;"
                                    class="fontMS700 text-center colorPrincipal font-40">
                                    REFLEXIONES SOBRE LA POLÍTICA <br>
                                </p>
                            </div>
                            <div class="col-sm-2" style="padding:0%">
                                <img class="LineSubsec bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                            </div>
                        </div>
                        <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            NACIONAL E INTERNACIONAL
                        </p>
                        <div class="c100">
                            <img class="lineCel mt-3" width="100%" 
                                src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                        </div>
                        <div class="row mt-5">
                            <div class="col-sm-12">
                                <p class="fontMS500 text-justify font-24 p2">
                                    DORA MEYER FUE UNA DEFENSORA INCANSABLE DE LA EQUIDAD Y LA JUSTICIA INDEPENDIENTE. 
                                    SE DECLARÓ NEUTRAL Y REHUSÓ TODA AFILIACIÓN POLÍTICA. BUSCÓ JUZGAR DE MANERA 
                                    IMPARCIAL LAS PROPUESTAS REVOLUCIONARIAS DE SU MOMENTO. RECHAZÓ EL SOCIALISMO DE 
                                    MARIÁTEGUI POR SER EUROPEIZANTE Y EXPRESÓ RESERVAS SOBRE VÍCTOR RAÚL HAYA DE LA 
                                    TORRE. RESERVÓ SU CRÍTICA MÁS AGUDA PARA EL PRESIDENTE AUGUSTO B. LEGUÍA. EN EL 
                                    ONCENIO DE LEGUÍA (1933), LO TILDA DE OPORTUNISTA Y TRAIDOR A LA PATRIA. PRESENTA 
                                    UN ESTUDIO DETALLADO DE LOS MONOPOLIOS EXTRANJEROS ESTABLECIDOS DURANTE SU PRESIDENCIA, 
                                    CRITICA EL ROL DEL CAPITAL NORTEAMERICANO Y DOCUMENTA LA DEUDA CRECIENTE.
                                    <br><br>
                                </p>
                                <p class="fontMS100 text-justify text-gris font-24">
                                    En la década de 1930, Dora Mayer declaró su admiración por el presidente Sánchez Cerro, e 
                                    incluso llega a publicar en Crisol, el órgano de su partido, en ese momento abiertamente 
                                    fascista. Por ese hecho se ha insinuado el supuesto «lado oscuro» de Dora Mayer; sin embargo, 
                                    sus ensayos y artículos parecen sugerir que nunca abandonó su lucha por la tolerancia y la 
                                    solidaridad. Aún más, en la colección de ensayos El indígena y los Congresos Panamericanos 
                                    rechaza el nazismo y el fascismo europeo. 
                                </p>
                            </div>
                        </div>
                        <div class="row" style="margin-top:5%">
                            <div class="col-sm-2"></div>
                            <div class="col-sm-4 libro mt-3">
                                <a href="http://hdl.handle.net/20.500.14428/79176" target="_blank" style="color: black;">
                                    <img class="p2" width="100%" height="100%"
                                        src="/assets/images/micrositio/micrositio16/DM_029.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS500">
                                                Dora Mayer. 
                                                <br>
                                            </span>
                                            <span class="fontMS100Italic">
                                                El oncenio de Leguía.   
                                                <br>
                                            </span>
                                            Tip. Peña, 1933.
                                        </p>
                                    </div>
                                </a>
                            </div>
                            <div class="col-sm-4 libro mt-3">
                                <a href="http://hdl.handle.net/20.500.14428/79165" target="_blank" style="color: black;">
                                    <img class="p2" width="100%" height="100%"
                                        src="/assets/images/micrositio/micrositio16/DM_022.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS500">
                                                Dora Mayer. 
                                                <br>
                                            </span>
                                            <span class="fontMS100Italic">
                                                El indígena y los congresos panamericanos. Viejos vicios y nuevas miras en el Perú y en Sudamérica. Segunda Parte.  
                                                <br>
                                            </span>
                                            [s.n.], 1938.    
                                        </p>
                                    </div>
                                </a>
                            </div>
                            <div class="col-sm-2"></div>
                        </div>
                        <br><br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mb-3" width="100%" 
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-8" style="padding:0%">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EL LEGADO DE DORA MAYER <br>
                        </p>
                    </div>
                    <div class="col-sm-2" style="padding:0%">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel mt-3" width="100%" 
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada3.png">
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-6 bottom_cel">
                        <p class="fontMS500 font-24 mr-3">
                            EL LEGADO DE DORA MEYER ES AMPLIO Y PROLÍFICO, Y ABARCA TANTO EL 
                            ÁMBITO PERIODÍSTICO COMO EL SOCIAL, EL POLÍTICO Y EL DE 
                            DIVULGACIÓN CIENTÍFICA. FUE, ADEMÁS, UNA PROMOTORA INFATIGABLE 
                            DE LOS DERECHOS DE LAS MUJERES, LOS INDÍGENAS Y LOS AFRODESCENDIENTES. 
                            <br>
                        </p>
                        <br>
                        <p class="fontMS100 font-24 mr-5">
                            <span class="fontMS500Italic">Legado social</span>. Lucho incansablemente por los derechos de los indígenas, 
                            y denunció a través  de sus escritos la discriminación y el racismo. Fue fundadora de la Asociación Pro-Indígena.  
                            Asimismo, fue parte del pensamiento feminista del país, destacando el rol de las mujeres en el hogar y la vida social. 
                            <br>
                            <span class="fontMS500Italic">Legado periodístico</span>. Fue un ejemplo de independencia respecto a los poderes políticos de turno, 
                            intentando hacer llegar al público una información fidedigna y pegada a la verdad. 
                            Dirigió el periódico El Deber Pro-Indígena y La Crítica, entre otros.  
                            <br>
                            <span class="fontMS500Italic">Legado literario</span>. Dejó como legado varias obras sobre diversos temas, 
                            principalmente sobre la problemática social del Perú, tales como El Indígena y su derecho y La China silenciosa y elocuente, 
                            estudio sobre la inmigración china al Perú. 
                            <br><br>
                            DEL MISMO MODO, SE DEBE SEÑALAR QUE DORA MAYER FUE PROMOTORA INFANTIGABLE 
                            DE LA OBRA Y EL PENSAMIENTO FILOSÓFICO DE PEDRO S. ZULEN.  
                            <br>
                        </p>
                    </div>
                    <div class="col-sm-6 c100">
                        <p class="fontMS500 font-24">
                            LA OBRA DE DORA MAYER HA SIDO OPACADA POR SU VÍNCULO CON
                            PEDRO ZULEN. ESTE OLVIDO SE DEBE, EN PARTE, A LAS ACCIONES DE LA
                            PROPIA DORA MAYER, QUIEN FUE PROMOTORA INFATIGABLE DE LA
                            OBRA Y EL PENSAMIENTO FILOSÓFICO DE ZULEN. <br>
                        </p>
                        <br>
                        <p class="fontMS100 font-24">
                            Al mismo tiempo, no se puede dejar de lado el impacto del supuesto asunto
                            Zulen-Mayer. En 1915, Dora Mayer declaró su amor por su colega y
                            compañero de lucha. Según ella, fue un amor no correspondido y su insistencia
                            frente a las negativas de Zulen provocó un verdadero escándalo. Sea cual sea la
                            razón de la poca difusión de su obra, es una figura que merece más atención.
                            Como periodista colaboró en diversos medios periodísticos durante casi 60
                            años. Publicó decenas de folletos y libros sobre la interculturalidad, la
                            política, el anti-imperialismo, los derechos laborales y más. <br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <div class="row mb-5 bottom_cel">
                            <div class="col-sm-10" style="margin-top:15%">
                                <img width="100%" height="70%" src="/assets/images/micrositio/micrositio16/DM_023.jpg">
                                <br><br>
                                <p class="fontMS100 font-20 text-gris font-italic mt-2">
                                    Dora Mayer es homenajeada por la Asociación
                                    Nacional de Periodistas. Lima, 1950. Archivo
                                    Alionca Respaldiza Chavez.
                                </p>
                            </div>
                            <div class="col-sm-2"></div>
                        </div>
                        <div class="row mb-5 c100">
                            <div class="col-sm-12" style="margin-top:15%">
                                <img width="100%" src="/assets/images/micrositio/micrositio16/DM_023.jpg">
                                <br><br>
                                <p class="fontMS100 font-20 text-gris font-italic mt-2">
                                    Dora Mayer es homenajeada por la Asociación
                                    Nacional de Periodistas. Lima, 1950. Archivo
                                    Alionca Respaldiza Chavez.
                                </p>
                            </div>
                            <div class="col-sm-2"></div>
                        </div>
                        <div class="row">
                            <div class="col-sm-5 mt-3">
                                <img width="100%" height="100%" src="/assets/images/micrositio/micrositio16/DM_024.jpg">
                                <br><br>
                            </div>
                            <div class="col-sm-5 libro-small mt-3">
                                <a href="http://hdl.handle.net/20.500.14428/79629" target="_blank" style="color: black;">
                                    <img class="p2" width="100%" height="100%"
                                        src="/assets/images/micrositio/micrositio16/DM_025.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS500">
                                                Miguelina Acosta.
                                                <br>
                                            </span>
                                            <span class="fontMS100Italic">
                                                Dora Mayer. 
                                                <br>
                                            </span>
                                            El Tiempo, 21 de agosto de 1916.     
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-5">
                                <p class="fontMS100 font-20 text-gris font-italic mt-2">
                                    A través de este testimonio, Dora Mayer
                                    retrata con franqueza los principales episodios
                                    de su enredo afectivo con Pedro Zulen.
                                </p>
                            </div>
                            <div class="col-sm-5"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container_Morado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-3">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-40">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-9">
                        <img id="img_dialogo"
                            src="/assets/images/micrositio/micrositio8/ET04_MS011_EGU_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <p class="text-white text-justify font-24">
                    José Carlos Mariátegui criticó la Asociación Pro-Indígena por ser una institución protectora,
                    ajena a las comunidades que defendía. En su réplica, publicada en <span class="fontMS100Italic">Amauta</span>, Dora Mayer no refuta
                    esta premisa. Explica que la Asociación logró documentar la magnitud del problema y ofreció
                    apoyo legal de manera gratuita.
                </p>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            En la correspondencia seleccionada, ¿qué tipo de
                            problemas describen los autores de las cartas?, ¿y qué
                            tipo de ayuda ofrece la Asociación?
                        </p>
                        <img class="c100 mt-3" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            ¿Qué entendemos como índigena, indio o población originaria? ¿Los términos
                            describen al mismo grupo social? ¿Cómo se han
                            transformado en el último siglo?
                        </p>
                        <img class="c100 mt-3" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS500 text-white font-24">
                            Dora Mayer elaboró un análisis meticuloso de los
                            abusos laborales en las industrias mineras y
                            caucheras. ¿Cuál es el estado actual de la explotación de
                            recursos en la Amazonía y la Sierra Central?
                        </p>
                        <img class="c100 mt-3" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio9/ET04_MS14_MATTO__LINEA1-recortada4.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Barclay, F. (2010) </span><br>
                            <span class="fontMS100Italic text-gris">La Asociación Pro-indígena y las atrocidades
                                del Putumayo, una misión auto-restringida.
                            </span>
                            <span class="text-gris">En: Boletín Americanista, número 60, pp. 143-163.</span><br>
                            <a href="https://revistes.ub.edu/index.php/BoletinAmericanista/article/view/13164/16504 " target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Jancsó, K. (2013). </span><br>
                            <span class="fontMS100Italic text-gris">La Asociación Pro-Indígena. </span>
                            <span class="text-gris">Cátedra
                                Mariátegui, Año III, no. 14.</span><br>
                            <a href="https://www.catedramariategui.com/anteriores/2013/13_Katalin.pdf" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Jancsó, K. (2012) </span><br>
                            <span class="fontMS100Italic text-gris">Dora Mayer en Amauta. </span>
                            <span class="text-gris">En: Humanidades y lenguas modernas, Universidad de Ricardo
                                Palma, no. 15, pp. 49-63. </span><br>
                            <a href="http://estudiosamericanos.revistas.csic.es/index.php/estudiosamericanos/article/view/310/315 "
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Molinari, T. & Aldana, S. (2015)</span><br>
                            <span class="fontMS100Italic text-gris">El complejo periplo intelectual y político de
                                Dora Mayer.
                            </span>
                            <span class="text-gris">En: Revista de Sociología, volumen 25, pp. 247-276. </span><br>
                            <a href="https://revistasinvestigacion.unmsm.edu.pe/index.php/sociologia/article/view/19053" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Rojas, J. (2018) </span><br>
                            <span class="fontMS100Italic text-gris">Los espectros de Dora Mayer. </span>
                            <span class="text-gris">En: El sol que disipa las nubes. Textos esenciales. Fondo
                                Editorial del Congreso del Perú </span><br>
                            <a href="https://www.academia.edu/38870916/Los_espectros_de_Dora_Mayer?source=swp_share " target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">Zegarra Flórez, M. (2009) </span><br>
                            <span class="fontMS100Italic text-gris">Dora Mayer, los indígenas y la nación
                                peruana a inicios del siglo XX.
                            </span>
                            <span class="text-gris">En: Anuario de Estudios Americanos. Vol. 66, no. 1, p. 251-288.</span><br>
                            <a href="https://dialnet.unirioja.es/servlet/articulo?codigo=3039628"
                                target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
